import React, { useState, useEffect } from 'react';
import TripApplicationModal from './TripApplicationModal';

const TripApplicationModalWrapper: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [tripData, setTripData] = useState<{
    id: string;
    title: string;
    date: string;
    price: string;
  } | null>(null);

  useEffect(() => {
    const handleModalTrigger = (event: Event) => {
      const target = event.target as HTMLElement;
      if (target.matches('[data-bs-target="#tripApplicationModal"]')) {
        event.preventDefault();
        
        const button = target as HTMLButtonElement;
        setTripData({
          id: button.dataset.tripId || '',
          title: button.dataset.tripTitle || '',
          date: button.dataset.tripDate || '',
          price: button.dataset.tripPrice || ''
        });
        setIsOpen(true);
      }
    };

    document.addEventListener('click', handleModalTrigger);
    return () => document.removeEventListener('click', handleModalTrigger);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setTripData(null);
  };

  return (
    <TripApplicationModal
      isOpen={isOpen}
      onClose={handleClose}
      tripData={tripData}
      closeOnOverlayClick={true}
      closeOnEscape={true}
    />
  );
};

export default TripApplicationModalWrapper;